import { SmoothScrollOptions } from '../interfaces/scroll.interface';

export const smoothScrollToElement = (
  selector: string,
  options: SmoothScrollOptions = {},
): void => {
  const {
    offset = 250,
    duration = 800,
    delay = 100,
  } = options;

  setTimeout(() => {
    const element = document.querySelector(selector);
    if (!element) {
      return;
    }

    const elementPosition = element.getBoundingClientRect().top;
    const offsetPosition = elementPosition + window.pageYOffset - offset;
    const startPosition = window.pageYOffset;
    const distance = offsetPosition - startPosition;
    let start: number | null = null;

    const smoothScroll = (currentTime: number) => {
      start ??= currentTime;
      const timeElapsed = currentTime - start;
      const progress = Math.min(timeElapsed / duration, 1);
      const ease = 1 - (1 - progress) ** 3;
      window.scrollTo(0, startPosition + distance * ease);
      if (timeElapsed < duration) {
        requestAnimationFrame(smoothScroll);
      }
    };
    requestAnimationFrame(smoothScroll);
  }, delay);
};
